import * as React from 'react';
// Using a react pattern to avoid the 'useMemo' and 'useCallback', where the hook only export the 'state' and 'dispatch', and all the handlers stay out of the hook.

const getInitialRowsPerPage = (customInitialRowsPerPage, paginationOptions) => {
  const canUseCustomInitialRowsPerPage = customInitialRowsPerPage && paginationOptions.includes(customInitialRowsPerPage);
  const initialRowsPerPage = canUseCustomInitialRowsPerPage ? customInitialRowsPerPage : paginationOptions[0];
  return initialRowsPerPage;
};

// Hook
function usePagination({
  paginationOptions,
  initialRowsPerPage
}) {
  const [page, setPage] = React.useState(0);
  const defaultRowsPerPage = React.useRef(getInitialRowsPerPage(initialRowsPerPage, paginationOptions));
  const [rowsPerPage, setRowsPerPage] = React.useState(defaultRowsPerPage.current);
  React.useEffect(() => {
    defaultRowsPerPage.current = getInitialRowsPerPage(initialRowsPerPage, paginationOptions);
    setRowsPerPage(defaultRowsPerPage.current);
  }, [setRowsPerPage, initialRowsPerPage, paginationOptions]);
  const getPaginationProps = (size, isLoading) => ({
    page,
    rowsPerPage,
    count: size,
    onPageChange: (_, newPage) => {
      setPage(newPage);
    },
    onRowsPerPageChange: e => {
      setRowsPerPage(+e.target.value);
      setPage(0);
    },
    rowsPerPageOptions: paginationOptions,
    showFirstButton: true,
    showLastButton: true,
    nextIconButtonProps: isLoading ? {
      disabled: true
    } : undefined,
    backIconButtonProps: isLoading ? {
      disabled: true
    } : undefined,
    component: 'div'
  });
  return {
    getPaginationProps,
    page,
    rowsPerPage,
    paginationOptions,
    setPage
  };
}
export default usePagination;